
    <div class="free-main" [class.free-main-mini]="mini">
      <router-outlet></router-outlet>
    </div>
  


// WEBPACK FOOTER //
// /home/tg/github/freeng/src/app/app.component.ts.AppComponent.html